import { Helmet } from "react-helmet";
 
export default function HelmetMetaData(props) {
    let title = props.title !== "" ? props.title : "TeachOn";
    return (
        <Helmet>
          <title>{title}</title>
          </Helmet>
          )
}